module.exports = __webpack_public_path__ + "static/media/img-tag-moduleE1.6189b223.png";